module.exports = __webpack_public_path__ + "img/chuan1.d24bf4c9.png";